import { render } from "./Main.vue?vue&type=template&id=b7bb3756&scoped=true"
import script from "./Main.vue?vue&type=script&lang=ts"
export * from "./Main.vue?vue&type=script&lang=ts"

import "./Main.vue?vue&type=style&index=0&id=b7bb3756&scoped=true&lang=css"
import "./Main.vue?vue&type=style&index=1&id=b7bb3756&lang=css"
script.render = render
script.__scopeId = "data-v-b7bb3756"

export default script